import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import styles from './calendarViewInterviews.module.scss';
import { evaluateBasedOnResult, getSheduledInterviews, getHiringPiepelinesOfSheduledInterviews, getSheduledInterviewsOfDay, cancelSheduledInterview, cancelAndRejectInterview } from '../../../../../services/util/sheduleInterviews';
import CalendarDatePicker from "./CalendarDatePicker"; // Import your CalendarDatePicker component
import makeAnimated from 'react-select/animated';
import ViewScheduledInterview from '../viewScheduledInterview';
import EditSheduledInterviewsModal from '../editSheduledInterviewsModal';
import { CustomConfirmationModal } from '../../../../shared/customConfirmationModal';
import { CustomConfirmationBox } from '../../../../shared/customConfirmationBox';
import { useNavigate } from 'react-router-dom';
import { Col, Dropdown } from 'react-bootstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import CSSLoader from '../../../../shared/cssLoader';
import { toast } from 'react-toastify';

moment.locale("en-GB");
const localizer = momentLocalizer(moment);

export default function ReactBigCalendar(props) {
    const [eventsData, setEventsData] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());

    const animatedComponents = makeAnimated();

    const history = useNavigate();

    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);

    let selected_pipeline = (params.get('pipeline') ? params.get('pipeline') : null);
    const [showModal, setShowModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    let [filteredValues, setFilteredValues] = useState([]);
    let [isLoading, setLoading] = useState(false);
    let [sideLoading, setSideLoading] = useState(false);
    let [editRowValues, setEditRowValues] = useState();
    let [showRowValues, setShowRowValues] = useState();
    let [isdeleteLoading, setDeleteLoading] = useState(false);
    let [isSubmitLoading, setSubmitLoading] = useState(false);
    const [modal, setModal] = useState({
        isOpen: false,
        value: ''
    });
    let [evaluation, setEvaluation] = useState({
        is_modal_open: false,
        candidate_data_set: {}
    })
    const [Rejectmodal, setRejectModal] = useState({
        isOpen: false,
        value: ''
    });

    const changeSelectedPipeline = async (selected_pipeline_id) => {
        history({
            pathname: `/company/scheduled-interviews/table-view`,
            search: `?pipeline=${selected_pipeline_id}`
        });
    }




    const getAllSheduledInterviewValues = async () => {
        setLoading(true)
        let responds = await getHiringPiepelinesOfSheduledInterviews();

        if (responds.success === true) {
            let respond = await getSheduledInterviews(selected_pipeline);
            if (respond.success === true) {
                let array = [];
                if (respond.data.length < 1 && (selected_pipeline != 100)) {
                    changeSelectedPipeline(100);
                }
                await (respond.data).forEach(values => {
                    let time_difference = 0;
                    let minute_difference = 0;
                    let message = null;
                    let message_alert = null;

                    let current_time_utc = moment().utc();
                    let end_time = moment(values.shedule_date).zone(values.shedule_time_zone).utc();
                    time_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asHours());
                    minute_difference = (time_difference < 1) && parseInt(moment.duration(end_time.diff(current_time_utc)).asMinutes());

                    //message_alert 0=>Pending 1=>Ongoing -1=>Overdue
                    message_alert = (time_difference > 0 || minute_difference >= 0) ? 0 : (time_difference === 0 && minute_difference >= -59 && minute_difference < 0) ? 1 : (time_difference <= -1 && minute_difference < 0) && -1;
                    message = (time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0)) ? (time_difference < 1 ? `${minute_difference} min` : time_difference === 1 ? `${time_difference} hour` : `${time_difference} hours`) + ' left' : (time_difference === 0 && minute_difference >= -59) ? 'Now' : (time_difference <= 0 && minute_difference < 0) && 'Overdue';
                    array.push({
                        id: values.session_id,
                        start: moment.tz(values.shedule_date, values.shedule_time_zone).format('llll'),
                        schedule_date_time_utc: values.shedule_date,
                        end: moment.tz(values.shedule_date, values.shedule_time_zone).add(45, 'minutes').format('llll'),
                        time: moment.tz(values.shedule_date, values.shedule_time_zone).format('LT'),
                        time_zone: values.shedule_time_zone,
                        is_scheduled: values.is_scheduled,
                        title: values.candidate_name,
                        candidate_id: values.candidate_id,
                        position: values.position,
                        pipeline_name: values.pipeline_name,
                        interview_type: values.interview_type,
                        assigned_interviewers: values.assigned_interviewers,
                        interview_location_address: values.interview_location_address,
                        candidate_email: values.candidate_email,
                        country_code: values.candidate_mobile_country_code,
                        mnumber: values.candidate_mobile_number,
                        rsvpstatus: values.overall_rsvp_status,
                        interviewstatus: values.overall_interview_status,
                        interview_status_message: message,
                        interview_status_alert: message_alert,
                        candidateRSVP: values.candidate_rsvp,
                        candidateInterviewState: values.candidate_interview_status,
                        enable_evaluate_candidate_based_on_current_feedbacks: values.enable_evaluate_candidate_based_on_current_feedbacks,
                        guidelineDescription: values.interview_guidelines_to_candidate,
                        pipeline_step_name : values.pipeline_step_name? 'a': null,
                    })
                });

                setFilteredValues(array);
                setLoading(false)
                let result = await retriveSheduleInterviewsOfDay(selectedDate);
                setSideViewInterview(result)
            } else {
                setLoading(false)
            }
        } else {
            setLoading(false)
        }

    }

    const confirmEvaluation = async () => {
        setSubmitLoading(true);
        let respond = await evaluateBasedOnResult(evaluation.candidate_data_set.id);
        if (respond.success === true) {
            setSubmitLoading(false);
            setEvaluation({ is_modal_open: false, candidate_data_set: {} });
            getAllSheduledInterviewValues();
        } else {
            setSubmitLoading(false);
        }
    }

    const CustomEvent = ({ event }) => {
        return (
            <div className={event.interview_status_message == "Overdue" ? styles.custom_event : styles.second_custom_event}>
                <p className={event.interview_status_message == "Overdue" ? styles.eventPipelineNameText : styles.secondEventPipelineNameText}>{event.pipeline_name}</p>
                <div className={styles.second_row}>
                    <p className={event.interview_status_message == "Overdue" ? styles.eventTimeText : styles.secondEventTimeText}>{event.time}</p>
                    <p className={event.interview_status_message == "Overdue" ? styles.eventTimeZoneText : styles.secondEventTimeZoneText}>({event.time_zone})</p>
                </div>

            </div>
        );
    };

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99992C10.8334 9.53968 10.4603 9.16659 10.0001 9.16659C9.53984 9.16659 9.16675 9.53968 9.16675 9.99992C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 4.99992C10.4603 4.99992 10.8334 4.62682 10.8334 4.16659C10.8334 3.70635 10.4603 3.33325 10.0001 3.33325C9.53984 3.33325 9.16675 3.70635 9.16675 4.16659C9.16675 4.62682 9.53984 4.99992 10.0001 4.99992Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 16.6666C10.4603 16.6666 10.8334 16.2935 10.8334 15.8333C10.8334 15.373 10.4603 14.9999 10.0001 14.9999C9.53984 14.9999 9.16675 15.373 9.16675 15.8333C9.16675 16.2935 9.53984 16.6666 10.0001 16.6666Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            getAllSheduledInterviewValues();
        }
        return () => { unmounted = true };
    }, []);

    const [sideViewInterview, setSideViewInterview] = useState(null);

    const handleSelectedEvents = async (value) => {
        let result = await retriveSheduleInterviewsOfDay(value.schedule_date_time_utc);
        setSelectedDate(new Date(value.schedule_date_time_utc));
        setSideViewInterview(result)
    };

    const onShowMore = useCallback(
        async (events, date) => {
            try {
                let result = await retriveSheduleInterviewsOfDay(events[0].schedule_date_time_utc);
                setSelectedDate(new Date(events[0].schedule_date_time_utc));
                setSideViewInterview(result);
            } catch (error) {
                toast.error(<div>{"Issue in load data"}</div>, {
                    position: "top-right",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        },
        [getSheduledInterviewsOfDay]
    );

    const onSelectSlot = useCallback(async (slotInfo) => {
        try {
            let result = await retriveSheduleInterviewsOfDay(moment(slotInfo.end).add(1, 'hours'))
            setSelectedDate(new Date(slotInfo.start));
            setSideViewInterview(result);
        } catch (error) {
            toast.error(<div>{"Issue in load data"}</div>, {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    })

    const handleDateChange = async (date) => {
        let result = await retriveSheduleInterviewsOfDay(moment(date).add(1, 'hours'))
        setSideViewInterview(result)
        setSelectedDate(new Date(date));
    };

    const retriveSheduleInterviewsOfDay = async (value) => {
        setSideLoading(true);
        let respond = await getSheduledInterviewsOfDay(value);
        let array = [];
        if (respond.success === true) {
            await (respond.data).forEach(values => {
                let time_difference = 0;
                let minute_difference = 0;
                let message = null;
                let message_alert = null;

                let current_time_utc = moment().utc();
                let end_time = moment(values.shedule_date).zone(values.shedule_time_zone).utc();
                time_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asHours());
                minute_difference = (time_difference < 1) && parseInt(moment.duration(end_time.diff(current_time_utc)).asMinutes());

                //message_alert 0=>Pending 1=>Ongoing -1=>Overdue
                message_alert = (time_difference > 0 || minute_difference >= 0) ? 0 : (time_difference === 0 && minute_difference >= -59 && minute_difference < 0) ? 1 : (time_difference <= -1 && minute_difference < 0) && -1;
                message = (time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0)) ? (time_difference < 1 ? `${minute_difference} min` : time_difference === 1 ? `${time_difference} hour` : `${time_difference} hours`) + ' left' : (time_difference === 0 && minute_difference >= -59) ? 'Now' : (time_difference <= 0 && minute_difference < 0) && 'Overdue';
                array.push({
                    id: values.session_id,
                    schedule_date: moment.tz(values.shedule_date, values.shedule_time_zone).format('llll'),
                    start: moment.tz(values.shedule_date, values.shedule_time_zone).format('llll'),
                    schedule_date_time_utc: values.shedule_date,
                    end: moment.tz(values.shedule_date, values.shedule_time_zone).add(45, 'minutes').format('llll'),
                    time: moment.tz(values.shedule_date, values.shedule_time_zone).format('LT'),
                    time_zone: values.shedule_time_zone,
                    is_scheduled: values.is_scheduled,
                    candidate_name: values.candidate_name,
                    candidate_id: values.candidate_id,
                    position: values.position,
                    pipeline_name: values.pipeline_name,
                    interview_type: values.interview_type,
                    assigned_interviewers: values.assigned_interviewers,
                    interview_location_address: values.interview_location_address,
                    candidate_email: values.candidate_email,
                    country_code: values.candidate_mobile_country_code,
                    mnumber: values.candidate_mobile_number,
                    rsvpstatus: values.overall_rsvp_status,
                    interviewstatus: values.overall_interview_status,
                    interview_status_message: message,
                    interview_status_alert: message_alert,
                    candidateRSVP: values.candidate_rsvp,
                    candidateInterviewState: values.candidate_interview_status,
                    enable_evaluate_candidate_based_on_current_feedbacks: values.enable_evaluate_candidate_based_on_current_feedbacks,
                    guidelineDescription: values.interview_guidelines_to_candidate,
                    pipeline_step_name: values.pipline_step_name,
                    online_interview_url: values.interview_url,
                })
          
            });

            setSideLoading(false);
        }
        else {
            setSideLoading(true);
        }

        return array;
    }

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    const modalClose = () => setShowDetailsModal(false);
    const modalShow = () => setShowDetailsModal(true);

    const showSheduledInterview = async (value) => {
        await setShowRowValues(value)
        modalShow()
    }

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const editSheduledInterview = async (value) => {
        await setEditRowValues(value)
        handleShow()
    }

    const onSelectCancelTab = (value) => {
        setModal({
            isOpen: true,
            value: value
        })
    }

    const onSelectCancelAndRejectTab = (value) => {
        setRejectModal({
            isOpen: true,
            value: value
        })
    }

    //cancel and reject candidate
    const submitRejectAndCancel = async (values) => {
        setDeleteLoading(true);
        let result = await cancelAndRejectInterview(Rejectmodal.value, values.reason, values.secondaryActionCheckboxChecked);
        if (result.success === true) {
            setDeleteLoading(false);
            setRejectModal({
                isOpen: false,
                value: ''
            })
            props.GetTaskValues();
            getAllSheduledInterviewValues();
        } else {
            setDeleteLoading(false);
        }

    }

    //delete request submit
    const submitSuccess = async (values) => {
        setDeleteLoading(true);
        let interviewCancelEmailConfirmation = values.secondaryActionCheckboxChecked;
        let result = await cancelSheduledInterview(modal.value, interviewCancelEmailConfirmation);
        if (result.success === true) {
            setDeleteLoading(false);
            setModal({
                isOpen: false,
                value: ''
            })
            props.GetTaskValues();
            getAllSheduledInterviewValues();
        } else {
            setDeleteLoading(false);
        }

    }

    const customToolbar = (toolbar) => {
        const goToBack = () => {
            toolbar.date.setMonth(toolbar.date.getMonth() - 1);
            toolbar.onNavigate("prev");
        };

        const goToNext = () => {
            toolbar.date.setMonth(toolbar.date.getMonth() + 1);
            toolbar.onNavigate("next");
        };

        return (
            <div className={styles.rbc_toolbar}>
                <span className={styles.rbc_btn_group}>
                    <button type="button" onClick={goToBack}>
                        <div className={styles.toolBarBackIcon}>
                            <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.3487 18.5959L2.15332 10.4005L10.3487 2.20508" stroke="black" stroke-width="2.73181" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </button>
                    <span className={styles.rbc_toolbar_label}>{toolbar.label}</span>

                    <button type="button" onClick={goToNext}>
                        <div className={styles.toolBarNextIcon}>
                            <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.7168 18.5959L9.91222 10.4005L1.7168 2.20508" stroke="black" stroke-width="2.73181" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </button>
                    <CalendarDatePicker
                        selectedDate={selectedDate}
                        onChange={handleDateChange}
                    />
                </span>

            </div>
        );
    };

    return (
        <div className={styles.main_container}>
            {
                showDetailsModal === true ?
                    (<ViewScheduledInterview modalClose={modalClose} showDetailsModal={showDetailsModal} showRowValues={showRowValues} getAllSheduledInterviewValues={getAllSheduledInterviewValues} />)
                    : null
            }
            {
                showModal === true ?
                    (<EditSheduledInterviewsModal handleClose={handleClose} showModal={showModal} editRowValues={editRowValues} getAllSheduledInterviewValues={getAllSheduledInterviewValues} />)
                    : null
            }
            {/* submit cancel interview request alert confirmation start */}
            <CustomConfirmationModal
                show={modal.isOpen}
                confirmationType='danger'
                cancelIconclick={() => setModal({ isOpen: false, value: '' })}
                onSecondaryBtnClick={() => setModal({ isOpen: false, value: '' })}
                onFormSubmit={submitSuccess}
                isSecondaryBtnDisabled={isdeleteLoading === true ? true : false}
                isPrimaryBtnDisabled={isdeleteLoading === true ? true : false}
                primaryBtnBackSideIcon={isdeleteLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage="Once you cancel scheduled interview, all details relevent to current interview schedule details will be deleted."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Cancel!"
                secondaryCheckboxLabel="Send a cancel interview email notification to the candidate."
                secondaryActionCheckboxChecked={true}
            />
            {/* submit cancel interview request alert confirmation end */}

            {/* submit cancel and reject interview request alert confirmation start */}
            <CustomConfirmationBox
                show={Rejectmodal.isOpen}
                cancelIconclick={() => setRejectModal({ isOpen: false, value: '' })}
                onSecondaryBtnClick={() => setRejectModal({ isOpen: false, value: '' })}
                onFormSubmit={submitRejectAndCancel}
                isSecondaryBtnDisabled={isdeleteLoading === true ? true : false}
                isPrimaryBtnDisabled={isdeleteLoading === true ? true : false}
                primaryBtnBackSideIcon={isdeleteLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                topic="Are you sure?"
                message="You are trying to cancel and reject selected candidate from current stage."
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="defaultBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="submit"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Cancel and Reject !"
                checkboxLabel="I confirm to cancel and reject candidate schedule interview."
                secondaryCheckboxLabel="Send a cancel interview email notification to the candidate."
                secondaryActionCheckboxChecked={true}
            />
            {/* submit cancel and reject interview request alert confirmation end */}

            {/* evaluate candidate based on current result confirmation start */}
            <CustomConfirmationModal
                show={evaluation.is_modal_open}
                confirmationType='danger'
                cancelIconclick={() => setEvaluation({ is_modal_open: false, candidate_data_set: {} })}
                onSecondaryBtnClick={() => setEvaluation({ is_modal_open: false, candidate_data_set: {} })}
                onPrimaryBtnClick={confirmEvaluation}
                isSecondaryBtnDisabled={isSubmitLoading === true ? true : false}
                isPrimaryBtnDisabled={isSubmitLoading === true ? true : false}
                primaryBtnBackSideIcon={isSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                confirmationMessage="Once you submit evaluate candidate based on candidate result system will automatically pass/fail candidate based on current marks"
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Yes, Submit!"
            />
            {/* evaluate candidate based on current result confirmation end */}

            <div className={styles.first_view}>
                {isLoading === true ?
                    (<div className={styles.loadingDiv}>
                        <Col sm={{ span: 4, offset: 4 }}>
                            <CSSLoader />
                        </Col>
                    </div>)
                    :
                    <Calendar
                        className={styles.calendar_view}
                        views={["month"]}
                        selectable
                        localizer={localizer}
                        defaultDate={new Date()}
                        defaultView="month"
                        events={filteredValues}
                        onSelectEvent={(event) => handleSelectedEvents(event)}
                        components={{
                            toolbar: customToolbar
                            , event: CustomEvent
                        }}
                        onShowMore={onShowMore}
                        onSelectSlot={onSelectSlot}
                        date={selectedDate}
                    />
                }
            </div>

            <div className={styles.second_view}>
                <div className={styles.date_section}>
                    <p className={styles.mainDateText}>
                        {selectedDate.toDateString() === new Date().toDateString()
                            ? `${moment(selectedDate).format("ddd MMM DD YYYY")} (Today)`
                            : moment(selectedDate).format("ddd MMM DD YYYY")}
                    </p>
                </div>
                {sideLoading === true ?
                    (<div className={styles.loadingDiv}>
                        <Col sm={{ span: 4, offset: 4 }}>
                            <CSSLoader />
                        </Col>
                    </div>)
                    :
                    <>
                        {sideViewInterview &&
                            <>
                                {(sideViewInterview).map((value) =>
                                    <div key={value.session_id} className={value.interview_status_message == "Overdue" ? styles.interview_mini_card : styles.second_interview_mini_card}>
                                        <div className={styles.interviewPipelineDetail}>
                                            <p className={value.interview_status_message == "Overdue" ? styles.pipelineNameText : styles.secondPipelineNameText}>{value.pipeline_name}</p>
                                            <div className={styles.tableOptionIconDiv}>
                                                <Dropdown
                                                    alignRight={true}
                                                >
                                                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className={styles.dropdownMenu}>
                                                        <Dropdown.Item
                                                            onClick={() => viewCandidate(value.candidate_id)}
                                                            className={styles.dropdownText}>View Candidate</Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => showSheduledInterview(value)}
                                                            className={styles.dropdownText}>View Interview Schedule</Dropdown.Item>
                                                        <Dropdown.Item className={styles.dropdownText}
                                                            onClick={() => editSheduledInterview(value)}
                                                        >Reschedule Interview</Dropdown.Item>
                                                        {value.enable_evaluate_candidate_based_on_current_feedbacks &&
                                                            <div>
                                                                <Dropdown.Item className={styles.dropdownText}
                                                                    onClick={() => setEvaluation({ is_modal_open: true, candidate_data_set: value })}
                                                                >Evaluate Candidate with Current Result</Dropdown.Item>
                                                            </div>
                                                        }
                                                        <Dropdown.Divider />
                                                        <Dropdown.Item className={styles.dropdownTextDisabled}
                                                            onClick={() => onSelectCancelTab(value.id)}
                                                        >Cancel Interview</Dropdown.Item>
                                                        <Dropdown.Item className={styles.dropdownTextDisabled}
                                                            onClick={() => onSelectCancelAndRejectTab(value.id)}
                                                        >Cancel Interview / Reject Candidate</Dropdown.Item>

                                                        <ReactTooltip id={`InterviewPermissionInfo`} place="left" type="dark" effect="solid" >
                                                            <div className={styles.toolTipBox}>{<p>Permission Denied.</p>}</div>
                                                        </ReactTooltip>

                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className={styles.interviewSheduleDetails}>
                                            <p className={styles.sheduleDateText}>{value.time} </p>
                                            <p className={styles.sheduleZoneText}>({value.time_zone})</p>
                                        </div>
                                        <div className={styles.interviewCandidateDetails}>
                                            <p className={styles.candiateNameText}>{value.candidate_name} </p>
                                            <p className={styles.candidateEmailText}>({value.candidate_email})</p>
                                        </div>
                                    </div>
                                )}

                            </>
                        }
                        {sideViewInterview?.length === 0 &&
                            <div className={styles.noSheduleInterviewDiv}>
                                <p  className={styles.noSheduleInterviewText}>No Scheduled Interviews</p>
                            </div>
                        }
                    </>
                }
            </div>
        </div >
    );
}
